<!--<ng-container *ngIf="attachment">
  <div [ngStyle]="{'background-image': 'url(' + attachment.fileLink + ')'}" style="
    width: 100%;
  min-height: 300px;
    background-size: cover;
    background-position: center;
"></div>
</ng-container>-->

<form [formGroup]="form" class="mt-4">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group validateMe">
        <label class="form-label" for="Title">{{'lang.globals.title' | translate}}</label>
        <input class="form-control" formControlName="Title" id="Title" sbAutofocus
               type="text">
        <!--        <span class="form-text text-muted">{{'lang.campaignEdit.titleDescription' | translate}}</span>-->
        <div *ngIf="Title.touched && Title.errors?.required" class="alert alert-danger">
          {{'lang.globals.title' | translate}}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group validateMe">
        <label class="form-label" for="Description">{{'lang.globals.description' | translate}}</label>
        <input class="form-control" formControlName="Description" id="Description" type="text">
        <!--        <span class="form-text text-muted">{{'lang.campaignEdit.titleDescription' | translate}}</span>-->
        <div *ngIf="Description.touched && Description.errors?.required" class="alert alert-danger">
          {{'lang.globals.description' | translate}}</div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="form-group validateMe">
        <label class="form-label" for="DisplayTypeForm">{{'lang.globals.displayTypeForm' | translate}}</label>
        <select class="form-select" formControlName="DisplayTypeForm" id="DisplayTypeForm">
          <option *ngFor="let opt of displaySelection" [value]="opt">{{opt}}</option>
        </select>
        <span class="form-text text-muted">{{'lang.globals.displayTypeFormDescription' | translate}}</span>
      </div>
    </div>
    <div class="col-md-12">
      <button (click)="saveFileAttachment()" [disabled]="form.invalid" class="btn btn-success w-100">
        <ng-container *ngIf="attachment">
          <sb-icon icon="save"></sb-icon>&nbsp;{{'lang.globals.save' | translate}}
        </ng-container>
      </button>
    </div>
  </div>
</form>

